import { render, staticRenderFns } from "./MonetaryTemplate.html?vue&type=template&id=3bf64997&scoped=true&external"
import script from "./Monetary.vue?vue&type=script&lang=js"
export * from "./Monetary.vue?vue&type=script&lang=js"
import style0 from "./Monetary.vue?vue&type=style&index=0&id=3bf64997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf64997",
  null
  
)

export default component.exports